import {Component, OnInit} from '@angular/core';
import {FintechService} from "../../../services/fintech.service";
import {StoreSelectorsService} from "../../../services";
import {ofType} from "@ngrx/effects";
import {ActionsSubject} from "@ngrx/store";
import {Compbaser} from "../../../components/compbaser";
import {MatDialog} from "@angular/material/dialog";
import {switchMap} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {ToastrService} from "ngx-toastr";
import {DialogPopComponent} from "../../../components/dialog-pop/dialog-pop.component";
import {actionRestartAllStationsRequest} from "../../../store/actions/user.actions";

@Component({
  selector: 'app-fintech-recurring-status',
  templateUrl: './fintech-recurring-status.component.html',
  styleUrl: './fintech-recurring-status.component.scss'
})
export class FintechRecurringStatusComponent extends Compbaser implements  OnInit {

    accountStatus;
    accountStatusColor;
    lastPaymentDate;
    lastPaymentColor;
    lastPaymentMessage;


    constructor(dialog: MatDialog,
                public fintechService: FintechService,
                private storeSelector: StoreSelectorsService,
                private actionsSubj: ActionsSubject,
                private http: HttpClient,
                private toastr: ToastrService) {
        super(dialog);

        this.fintechService.notify$.subscribe( data => {
            if (this.fintechService.data.accountStatus != null) {
                this.updateAccountStatus();
            }
        });
    }

    updateAccountStatus() {
        this.lastPaymentDate = this.fintechService.data.accountStatus.lastPaymentDate;
        this.lastPaymentMessage = this.fintechService.data.accountStatus.lastPaymentMessage;
        if (this.fintechService.data.accountStatus != null) {
            switch (this.fintechService.data.accountStatus.status) {
                case "active":
                    this.accountStatus = "Active";
                    this.accountStatusColor = "green";
                    break;
                case "active_pending":
                    this.accountStatus = "Active";
                    this.accountStatusColor = "orange";
                    break;
                case "inactive":
                    this.accountStatus = "Not Active";
                    this.accountStatusColor = "red";
                    break;
            }

        }

        if (this.lastPaymentMessage == "succeeded") {
            this.lastPaymentColor = "green";
        } else if (this.lastPaymentMessage == "none") {
            this.lastPaymentColor = "white";
        } else {
            this.lastPaymentColor = "red";
        }
    }


    ngOnInit(): void {
    }

    showSubscribeButton() {
        return (this.fintechService.recurringMode == 0 || this.fintechService.data.accountStatus.status != 'active');
    }

    showUnsubscribeButton() {
        return (this.fintechService.recurringMode != 0 && this.fintechService.recurringMode != 5 && this.fintechService.data.accountStatus.status == 'active');
    }

    onResubscribe() {
        this.fintechService.setBusy(true);
        this.toastr.info('resubscribing...');
        const obs$ = this.fintechService.getPayerToken().pipe(
            switchMap( payerToken => {
                const url = "https://galaxy.signage.me/Web/resubscribeAccount.ashx";
                const options = {token: payerToken};
                return this.http.post(url, options);
            })
        );

        obs$.subscribe((res) => {
            this.fintechService.data.accountStatus.lastPaymentDate = (<any>res).lastPayment;
            if ((<any>res).result) {
                this.fintechService.data.accountStatus.status = "active";
                this.fintechService.data.accountStatus.lastPaymentMessage = "succeeded";
                this.fintechService.data.recurringMode = this.fintechService.recurringMode = 1;
                this.fintechService.updateAccountStatus(4);
                this.toastr.info('resubscribe succeeded');
            } else {
                this.fintechService.data.accountStatus.status = "inactive";
                this.fintechService.data.accountStatus.lastPaymentMessage = (<any>res).failMessage;
                this.toastr.error('resubscribe fail');
            }
            this.updateAccountStatus();
            this.fintechService.setBusy(false);
        });
    }

    onUnsubscribe() {
        const dialogRef = this.dialog.open(DialogPopComponent, {
            height: '250px',
            width: '400px',
            data: {name: `Unsubscribing will remove all Cards information from your account, and your account will become inactive at the end of the current billing cycle. Are you sure you want to proceed with unsubscribing?`, showCancel: true}
        });
        dialogRef.afterClosed().subscribe((r) => {
            if (r) {
                this.fintechService.setBusy(true);
                this.toastr.info('unsubscribing...');

                this.fintechService.unsubscribe().pipe(
                    switchMap( res => {
                        if ((<any>res).result) {
                            this.toastr.info('unsubscribe succeeded');
                        }
                        return this.fintechService.getFintechInfo();
                    })
                ).subscribe((res) => {
                    this.fintechService.setBusy(false);
                });

            }
        });

    }
}
